export const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
export const createUserEmail = process.env.REACT_APP_CREATE_USER_EMAIL || '';
export const company = process.env.REACT_APP_COMPANY.toLowerCase() || '';
export const disableAuth = process.env.REACT_APP_DISABLE_AUTH;
